import { Col, Row } from 'antd'
import { Footer } from 'antd/lib/layout/layout'
import { useAppKeyboard } from 'app/lib/hooks/useAppKeyboard'
import CapacitorService from 'app/lib/services/CapacitorService'
import { ComponentProps } from 'react'
import * as React from 'react'

interface Props extends ComponentProps<typeof Footer> {
  rowProps?: ComponentProps<typeof Row>
  colProps?: ComponentProps<typeof Col>
  children?: React.ReactNode
  sticky?: boolean
  removePadding?: boolean
}

const KFooter: React.FC<Props> = ({
  rowProps = { justify: 'end' },
  colProps,
  children,
  style,
  sticky = true,
  removePadding = false,
  ...others
}) => {
  const { visible } = useAppKeyboard()
  const height = CapacitorService.isIos() ? 100 : 75
  const styles = { padding: removePadding ? '16px 0 0 0' : undefined, ...style }

  return (
    <React.Fragment>
      {sticky && <div style={{ height, width: '100%' }} />}
      <Footer
        className={`kfooter ${sticky ? 'sticky' : ''} ${visible ? 'd-none' : ''}`}
        style={styles}
        {...others}>
        <Row {...rowProps}>
          <Col {...colProps}>{children}</Col>
        </Row>
      </Footer>
    </React.Fragment>
  )
}

export default KFooter
